import { IBreadcrumb } from './breadcrumbs';
import { IListingSeoData } from './listingSeoData';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { TPublicWebV1SearchResponse_MlRanking } from '../../repositories/dailyrent/entities/response/PublicWebV1SearchResponse';

export interface IListingOffersState {
  offers: IDailyRentOfferForMobileSite[];
  page: number;
  status: null | EFetchStatus;
  maxOffersCount: number;
  currentOffersCount: number;
  mlRanking: TPublicWebV1SearchResponse_MlRanking | undefined;
  seoData: IListingSeoData;
  breadcrumbs: IBreadcrumb[] | null;
  hasMoreOffers: boolean;
}

export enum EFetchStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
  LOADING = 'loading',
}
